import React, { Component } from "react";
import "./MAMCASurveyResult.css";
import Cookie from 'js-cookie';
import {
    message, ConfigProvider, Divider,
    Table, Empty, Spin, Form, Button,
    Tabs, Row, Col, Icon, Select, InputNumber,
    Popover, Menu, Dropdown, Modal
} from 'antd';
import { Link } from "react-router-dom";
import ReactEcharts from 'echarts-for-react';

// import { Link } from "react-router-dom";
// import { cpus } from "os";
const TabPane = Tabs.TabPane;

//create actor modal
const ComForm = Form.create({ name: 'form_in_modal' })(
    // eslint-disable-next-line
    class extends Component {

        constructor(props) {
            super(props);
            this.state = {
                formList: []
            }
        }

        // addGroup = () => {
        //     const { Option } = Select;

        //     const {
        //         form, treeData
        //     } = this.props; //read all the property send from Alternative
        //     let { getFieldDecorator } = form;

        //     var formList = this.state.formList
        //     let groupItem = []
        //     treeData.forEach(obj => {
        //         let items = []
        //         obj.children.forEach(c => {
        //             items.push(
        //                 <Option key = {formList.length+c.key} value={formList.length+c.key}>{c.key}</Option>
        //             )
        //         })
        //         groupItem.push(
        //             <Form.Item 
        //             key = {"Question: " + obj.title}
        //             label={"Question: " + obj.title}>
        //                 {getFieldDecorator(`${formList.length}river${obj.title}`, {
        //                 })(
        //                     <Select mode="multiple" placeholder="Please select favourite colors">
        //                         {items}
        //                     </Select>,
        //                 )}
        //             </Form.Item>
        //         )

        //     })
        //     formList.push(
        //         <span key={"Group " + formList.length}>
        //             {groupItem}
        //         </span>

        //     )
        //     this.setState({
        //         formList: formList
        //     })
        // }
        // onSelect = (selectedKeys, info) => {
        //     console.log('selected', selectedKeys, info);
        //   };

        //   onCheck = (checkedKeys, info) => {
        //     console.log('onCheck', checkedKeys, info);
        //   };


        // addGroup = () => {
        //     const {
        //         form, treeData
        //     } = this.props; //read all the property send from Alternative
        //     let formList = this.state.formList

        //     formList.push(
        //         <span key={"Group " + formList.length}>
        //         <Form.Item
        //             key={"Group " + formList.length}
        //             label={"Group " + formList.length}
        //             name={"Group " + formList.length}
        //         >
        //             {form.getFieldDecorator(`Group ${formList.length}`, {
        //                 // rules: [{ required: true, message: `Please click at least one answer option for every question!` }],

        //             })(
        //                 <Tree
        //                     checkable
        //                     onSelect={this.onSelect}
        //                     onCheck={this.onCheck}
        //                     treeData={treeData}
        //                 />
        //                 )}
        //          </Form.Item>
        //         </span>
        //     )
        //     this.setState({
        //         formList: formList
        //     })
        //     console.log(formList[0])
        // }


        removeGroup = () => {
            let formList = this.state.formList
            formList.pop()
            this.setState({
                formList: formList
            })
        }
        render() {
            const {
                visible, onCancel, onCreate,
            } = this.props; //read all the property send from Alternative


            // const { getFieldDecorator } = form; //can get the input value
            const { Option } = Select;

            const {
                form, treeData
            } = this.props; //read all the property send from Alternative
            let { getFieldDecorator } = form;

            let formList = []

            let inputNumber = form.getFieldValue('inputNumber')

            for (let i = 0; i < inputNumber; i++) {
                let groupItem = []
                treeData.forEach(obj => {
                    let items = []
                    obj.children.forEach(c => {
                        items.push(
                            <Option key={c.key} value={c.key}>{c.key}</Option>
                        )
                    })
                    groupItem.push(
                        <Form.Item
                            key={"Question: " + obj.title}
                            label={"Question: " + obj.title}>
                            {getFieldDecorator(`${i}W%m$e${obj.title}`, {
                                rules: [
                                    { required: true, message: 'Please at select one answer option for every question!!' }
                                ], //set the rule
                            }, {
                            })(
                                <Select mode="multiple" placeholder="Please select answer options">
                                    {items}
                                </Select>,
                            )}
                        </Form.Item>
                    )

                })
                formList.push(
                    <span key={"Group " + i}>
                        <h4>Group {i}</h4>
                        {groupItem}
                    </span>

                )
            }

            return (
                <span>
                    <Modal
                        visible={visible} //control the showing of modal
                        title="Add comparison group"
                        okText="Generate"
                        onCancel={onCancel}
                        onOk={onCreate}
                    >
                        {/* <Button onClick={this.addGroup} type="primary"> <b>{"\uFF0B\n"}</b> Add one comparison group</Button>
                        <Button onClick={this.removeGroup} disabled={this.state.formList <= 0 ? true : false} type="primary" style={{ marginLeft: 8 }}> <b>{"\u002D\n"}</b> Remove one comparison group</Button> */}

                        <Form layout="horizontal">
                            <Form.Item label="Number of group">
                                {getFieldDecorator('inputNumber', { initialValue: 0 })(<InputNumber min={0} max={10} />)}
                            </Form.Item>
                            {formList}
                        </Form>
                    </Modal>
                </span>
            );
        }
    }
);


export default class MAMCASurveyResult extends Component {
    constructor(props) {
        super(props);
        const panes = [
            { title: 'Weights', key: '1' },
            { title: 'Scores', key: '2' },
            { title: 'Social-Economic profiles', key: '3' },
            // { title: 'Comparison', key: '4' }
        ];

        var menu = (
            <Menu onClick={this.handleMenuClick}>
                <Menu.Item key='0'>
                    1st menu item
              </Menu.Item>
                <Menu.Item key='1'>
                    2nd menu item
              </Menu.Item>
            </Menu>
        );

        this.state = {
            email: Cookie.get("email"),
            column: [],
            data: [],
            loading: true, //the loading status default true
            panes,
            menu,
            activeKey: '1',
            weightData: [],
            SDData: [],
            selectedQuestion: '0',
            treeData: [],
            comVisible: false,
            graphVisible: false,
            seriesSet: [],
            criteriaSet: [],
            comOption: {}
            // formList: [],
            // maximumGroup: 0
        };
    }


    handleMenuClick = (e) => {
        this.setState({
            selectedQuestion: e.key,
        });
    }


    onChange = (activeKey) => {
        this.setState({
            activeKey,
        });
    }
    getPieChartOption = () => {
        let option = {}
        let answerList = []
        if (this.state.SDData && this.state.SDData.length !== 0) {
            this.state.SDData[this.state.selectedQuestion].questionAnswer.forEach(q => {
                answerList.push(q.name)
            })
            option = {
                title: {
                    text: this.state.SDData[this.state.selectedQuestion].questionName,
                    // subtext: '纯属虚构',
                    left: 'center'
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} : {c} ({d}%)'
                },
                legend: {
                    top: 15,
                    left: 10,
                    orient: 'vertical',
                    data: answerList,
                    textStyle: {
                        fontSize: 16 // Set the legend font size here
                    }
                },

                series: [
                    {
                        name: 'Answer',
                        type: 'pie',
                        // radius: '75%',
                        // center: ['50%', '50%'],
                        data: this.state.SDData[this.state.selectedQuestion].questionAnswer,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            }
        }



        return option
    }


    onEvents = () => {
        return ({
            click: (params) => { //click event
                this.state.projectActor.actorCriteria.forEach(c => {
                    if (c.criteriaName === params.name && c.subCriteria && c.subCriteria.length !== 0) { //find the subCriteria
                        let criteriaSet = []
                        c.subCriteria.forEach(sub => {
                            criteriaSet.push(sub.subCriteriaName)
                        })
                        let series = []

                        let legend = []
                        let option = {}
                        let count = 0

                        this.state.seriesSet.forEach(s => {
                            legend.push('Group ' + count)
                            let seriesData = {
                                name: 'Group ' + count,
                                type: 'bar',
                                barGap: 0,
                                label: {
                                    show: true,
                                    position: 'insideBottom',
                                    distance: 15,
                                    align: 'left',
                                    verticalAlign: 'middle',
                                    rotate: 90,
                                    formatter: '{c}  {name|{a}}',
                                    fontSize: 16,
                                    rich: {
                                        name: {
                                            textBorderColor: '#fff'
                                        }
                                    }
                                }
                            }
                            let data = []
                            s.forEach(cri => { //each criterion series
                                if (cri.criteriaName === params.name && cri.children && cri.children.length > 0) {
                                    cri.children.forEach(subCri => {
                                        data.push(subCri.normalisedWeightNumber.toFixed(2))
                                    })
                                }
                            })
                            seriesData.data = data
                            count++
                            series.push(seriesData)
                        })
                        option = {
                            // color: ['#003366', '#006699', '#4cabce', '#e5323e'],
                            tooltip: {
                                trigger: 'axis',
                                axisPointer: {
                                    type: 'shadow'
                                }
                            },
                            legend: {
                                data: legend
                            },
                            toolbox: {
                                show: true,
                                orient: 'vertical',
                                left: 'right',
                                top: 'center',
                                feature: {
                                    mark: { show: true },
                                    dataView: { title: "show data", show: true, readOnly: false },
                                    // magicType: { show: true, type: ['line', 'bar', 'stack', 'tiled'] },
                                    // restore: { show: true },
                                    saveAsImage: { title: "Save" },
                                }
                            },
                            xAxis: [
                                {
                                    type: 'category',
                                    axisTick: { show: false },
                                    data: criteriaSet
                                }]
                            ,
                            yAxis: [
                                {
                                    type: 'value'
                                }
                            ],
                            series:
                                series

                        }

                        this.setState({
                            comOption: option
                        });
                    }
                })

            }
        })
    }


    // checkDisable() {
    //     if (this.state.maximumGroup <= this.state.formList.length) {
    //         return true
    //     }
    //     else {
    //         return false
    //     }
    // }


    // handleChart() {
    //     if (this.state.activeKey === "3") {
    //         return this.getPieChartOption()
    //     }
    //     else if (this.state.activeKey === "4") {
    //         return this.getComparisonChartOption()
    //     }
    //     else {
    //         return {}
    //     }
    // }

    //save all the form data of compare
    saveFormRef = (formRef) => {
        this.formRef = formRef;
    }

    //show or cancel compare modal
    showComModal = () => {
        this.setState({ comVisible: true });
    }

    handleComCancel = () => {
        this.setState({ comVisible: false });
    }

    showGraph = () => {
        this.setState({
            graphVisible: true,
        });
    }

    handleGraphOk = (e) => {
        this.setState({
            graphVisible: false,
        });
    }
    handleGraphCancel = (e) => {
        this.setState({
            graphVisible: false,
        });
    }

    graphReset = () => {
        let series = []

        let legend = []
        let option = {}
        let count = 0

        this.state.seriesSet.forEach(s => {
            legend.push('Group ' + count)
            let seriesData = {
                name: 'Group ' + count,
                type: 'bar',
                barGap: 0,
                label: {
                    show: true,
                    position: 'insideBottom',
                    distance: 15,
                    align: 'left',
                    verticalAlign: 'middle',
                    rotate: 90,
                    formatter: '{c}  {name|{a}}',
                    fontSize: 16,
                    rich: {
                        name: {
                            textBorderColor: '#fff'
                        }
                    }
                }
            }
            let data = []
            s.forEach(c => {
                data.push(c.normalisedWeightNumber.toFixed(2))
            })
            seriesData.data = data
            count++
            series.push(seriesData)
        })
        option = {
            // color: ['#003366', '#006699', '#4cabce', '#e5323e'],
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            legend: {
                data: legend
            },
            toolbox: {
                show: true,
                orient: 'vertical',
                left: 'right',
                top: 'center',
                feature: {
                    mark: { show: true },
                    dataView: { title: "show data", show: true, readOnly: false },
                    // magicType: { show: true, type: ['line', 'bar', 'stack', 'tiled'] },
                    // restore: { show: true },
                    saveAsImage: { title: "Save" },
                }
            },
            xAxis: [
                {
                    type: 'category',
                    axisTick: { show: false },
                    data: this.state.criteriaSet
                }]
            ,
            yAxis: [
                {
                    type: 'value'
                }
            ],
            series:
                series

        }

        this.setState({
            comOption: option
        });
    }

    handleSubmit = e => {
        // e.preventDefault();
        const form = this.formRef.props.form;
        form.validateFields((err, values) => {
            if (!err) {
                // console.log('Received values of form: ', values);
                let query = []

                for (let i = 0; i < 10; i++) { //maximum 10 groups
                    let group = {}
                    group.number = i
                    group.questions = []
                    for (var v in values) {
                        let match = v.split('W%m$e')
                        let n = values[v]
                        let num = i
                        if (match.length === 2 && match[0] === num.toString()) { //belongs to the group
                            let q = {}
                            this.state.projectActor.actorSurveySettings.actorQuestions.forEach(obj => {
                                if (obj.question === match[1])
                                    q.question = obj._id
                            })
                            q.option = n
                            group.questions.push(q)
                        }
                    }
                    if (group.questions.length !== 0) {
                        query.push(group)
                    }
                }
                fetch(`/project/generateChart`, { //REST create project
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        uid: this.props.match.params.projectid,
                        actid: this.props.match.params.actorid, //get the id of actor
                        query: query,
                    }),
                }).then(res => res.json())
                    .then(json => {
                        if (json.success) {
                            message.success(json.message); //create successfully, show message
                            let series = []

                            let legend = []
                            let option = {}
                            let count = 0

                            json.seriesSet.forEach(s => {
                                legend.push('Group ' + count)
                                let seriesData = {
                                    name: 'Group ' + count,
                                    type: 'bar',
                                    barGap: 0,
                                    label: {
                                        show: true,
                                        position: 'insideBottom',
                                        distance: 15,
                                        align: 'left',
                                        verticalAlign: 'middle',
                                        rotate: 90,
                                        formatter: '{c}  {name|{a}}',
                                        fontSize: 16,
                                        rich: {
                                            name: {
                                                textBorderColor: '#fff'
                                            }
                                        }
                                    }
                                }
                                let data = []
                                s.forEach(c => {
                                    data.push(c.normalisedWeightNumber.toFixed(2))
                                })
                                seriesData.data = data
                                count++
                                series.push(seriesData)
                            })
                            option = {
                                // color: ['#003366', '#006699', '#4cabce', '#e5323e'],
                                tooltip: {
                                    trigger: 'axis',
                                    axisPointer: {
                                        type: 'shadow'
                                    }
                                },
                                legend: {
                                    data: legend
                                },
                                toolbox: {
                                    show: true,
                                    orient: 'vertical',
                                    left: 'right',
                                    top: 'center',
                                    feature: {
                                        mark: { show: true },
                                        dataView: { title: "show data", show: true, readOnly: false },
                                        // magicType: { show: true, type: ['line', 'bar', 'stack', 'tiled'] },
                                        // restore: { show: true },
                                        saveAsImage: { title: "Save" },
                                    }
                                },
                                xAxis: [
                                    {
                                        type: 'category',
                                        axisTick: { show: false },
                                        data: this.state.criteriaSet
                                    }]
                                ,
                                yAxis: [
                                    {
                                        type: 'value'
                                    }
                                ],
                                series:
                                    series

                            }

                            this.setState({
                                comVisible: false,
                                // graphVisible: true,
                                seriesSet: json.seriesSet,
                                comOption: option
                            }); //make modal invisible
                            // console.log(json.series)
                        }
                    })
            }
        });
    };

    //get the profiles
    getProfiles = () => {
        fetch(`/project/getProfiles/${this.props.match.params.projectid}/${this.props.match.params.actorid}`, { //get the project id from link
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        }).then(res => res.json())
            .then(json => {
                if (json.success) {

                    if (json.project.projectAlternatives && json.project.projectAlternatives.length !== 0 && json.projectActor.actorSurveySettings.actorEvaluatable) {
                        const alternativeColumn = [{
                            title: 'Weights',
                            dataIndex: 'criteriaWeight',
                            key: 'criteriaWeight',
                            width: '9%',
                        },
                        { //the column title of the table
                            title: 'Criteria Name', //the title of column
                            dataIndex: 'criteriaName', //the data index can be used for searching, filtering
                            key: 'criteriaName',
                            // sorter: (a, b) => { if (a.criteriaName > b.criteriaName) { return -1; } if (a.criteriaName < b.criteriaName) { return 1; } return 0; },
                            // render: (text, record) => <Popover content={record.criteriaDescription} title="Description"><span style={{ cursor: "pointer" }}>{text}</span></Popover>, //make it clickable to the project
                            width: '15%',
                        },
                        {
                            title: '0',
                            dataIndex: 'score0',
                            key: 'score0',
                            width: '9%',
                        },
                        {
                            title: '1',
                            dataIndex: 'score1',
                            key: 'score1',
                            width: '9%',
                        },
                        {
                            title: '2',
                            dataIndex: 'score2',
                            key: 'score2',
                            width: '9%',
                        },
                        {
                            title: '3',
                            dataIndex: 'score3',
                            key: 'score3',
                            width: '9%',
                        },
                        {
                            title: '4',
                            dataIndex: 'score4',
                            key: 'score4',
                            width: '9%',
                        },
                        {
                            title: '5',
                            dataIndex: 'score5',
                            key: 'score5',
                            width: '9%',
                        },]

                        var alternativeTable = []

                        json.alternativeData.forEach(a => {
                            alternativeTable.push(
                                <span key={a._id}>
                                    <h3 style={{ marginTop: "1vh" }}>Alternative: {a.alternativeName}</h3>
                                    <Table columns={alternativeColumn}
                                        bordered
                                        rowKey={record => record._id} //unique key needed, so we use mongodb id
                                        dataSource={a.alternativeTable} //the data source is what we get after component mount
                                    />
                                    {/* <h3>The global mean score: {a.globaMeanScore.toFixed(2)}</h3> */}
                                    <h3>The performance indicator: {a.performanceIndicator.toFixed(2)}</h3>
                                    <Divider />
                                </span>
                            )

                        })
                    }
                    let menuItem = []
                    let treeData = []
                    let maximumGroup = 0
                    if (json.projectActor.actorSurveySettings.actorQuestions && json.projectActor.actorSurveySettings.actorQuestions.length > 0) { //SD questions
                        let x = 0
                        json.projectActor.actorSurveySettings.actorQuestions.forEach(obj => {
                            let m = 0
                            menuItem.push(
                                <Menu.Item key={x}>
                                    {obj.question}
                                </Menu.Item>)
                            x++
                            let d = {
                                title: obj.question,
                                key: obj.question,
                            }
                            let children = []
                            obj.questionOptions.forEach(q => {
                                children.push({
                                    title: q,
                                    key: q,
                                })
                                m++
                            })
                            if (obj.questionOpen) {
                                children.push({
                                    title: "others",
                                    key: "others",
                                })
                                m++
                            }
                            d.children = children
                            treeData.push(d)
                            if (m > maximumGroup) {
                                maximumGroup = m
                            }
                        })

                    }
                    let menu = (
                        <Menu onClick={this.handleMenuClick}>
                            {menuItem}
                        </Menu>
                    )
                    let criteriaSet = []
                    json.projectActor.actorCriteria.forEach(c => {
                        criteriaSet.push(c.criteriaName)
                    })

                    let panes = []
                    
                    if(json.projectActor.actorSurveySettings.actorWeightable){
                        panes.push({ title: 'Weights', key: '1' })
                    }
                    if(json.projectActor.actorSurveySettings.actorEvaluatable){
                        panes.push({ title: 'Scores', key: '2' })
                    }
                    if(json.projectActor.actorSurveySettings.actorQuestions && json.projectActor.actorSurveySettings.actorQuestions.length > 0){
                        panes.push({ title: 'Social-Economic profiles', key: '3' })
                    }

                    this.setState({
                        project: json.project,
                        profiles: json.profiles,
                        projectActor: json.projectActor,
                        projectName: json.projectName,
                        role: json.role,
                        weightData: json.weightData,
                        alternativeData: json.alternativeData,
                        loading: false,
                        alternativeTable: alternativeTable,
                        SDData: json.SDData,
                        menu: menu,
                        treeData: treeData,
                        maximumGroup: maximumGroup,
                        criteriaSet: criteriaSet,
                        panes: panes
                    })
                }
                else {
                    message.error(json.message); //create unsuccessful, show alert
                }
            })
    }

    copyWeight = () =>{
        fetch(`/project/copyWeight`, { //REST create project
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                uid: this.props.match.params.projectid,
                actid: this.props.match.params.actorid, //get the id of actor
                weightData: this.state.weightData
            }),
        }).then(res => res.json())
            .then(json => {
                if (json.success) {
                    message.success(json.message); //create successfully, show message
                    // this.getProfiles()
                }
                else{
                    message.error(json.message); //create unsuccessful, show alert
                }
            }
            )
    }

    // copyScores = () =>{
    //     console.log(this.state.alternativeData)
    // }

    componentDidMount() {
        try {
            this.getProfiles() //after render immediately get alternative list
        } catch (e) {
            alert(e);
        }
    }

    render() {
        const weightColumn = [
            { //the column title of the table
                title: 'Criteria Name', //the title of column
                dataIndex: 'criteriaName', //the data index can be used for searching, filtering
                key: 'criteriaName',
                sorter: (a, b) => { if (a.criteriaName > b.criteriaName) { return -1; } if (a.criteriaName < b.criteriaName) { return 1; } return 0; },
                render: (text, record) => <Popover content={record.criteriaDescription} title="Description"><span style={{ cursor: "pointer" }}>{text}</span></Popover>, //make it clickable to the project
                width: '15%',
            },
            {
                title: 'Not relative (0)',
                dataIndex: 'score0',
                key: 'score0',
                width: '9%',
            },
            {
                title: 'Least important (1)',
                dataIndex: 'score1',
                key: 'score1',
                width: '9%',
            },
            {
                title: 'Less important (2)',
                dataIndex: 'score2',
                key: 'score2',
                width: '9%',
            },
            {
                title: 'Middle (3)',
                dataIndex: 'score3',
                key: 'score3',
                width: '9%',
            },
            {
                title: 'More Important (4)',
                dataIndex: 'score4',
                key: 'score4',
                width: '9%',
            },
            {
                title: 'Most important (5)',
                dataIndex: 'score5',
                key: 'score5',
                width: '9%',
            },
            {
                title: 'Standard deviation',
                dataIndex: 'standardDeviation',
                key: 'standardDeviation',
                width: '9%',
            },
            {
                title: 'Not-normalized Weight',
                dataIndex: 'notNormalisedWeight',
                key: 'notNormalisedWeight',
                width: '9%',
            },
            {
                title: 'Normalised Weight',
                dataIndex: 'normalisedWeight',
                key: 'normalisedWeight',
                width: '9%',
            },
        ]

        return <div className="MAMCASurveyResult">
            <Spin size="large" tip="Loading..." spinning={this.state.loading}>
                <Row style={{ marginTop: "5vh" }} type="flex" justify="space-around">
                    <Col span={6}>
                        <h4>Project name: {this.state.projectName}</h4>
                    </Col>
                    <Col span={6}>
                        <h4>Actor group: {this.state.role}</h4>
                    </Col>
                </Row>
                <Divider />
                <Tabs
                    size={"large"}
                    onChange={this.onChange}
                    activeKey={this.state.activeKey}
                >
                    {this.state.panes.map(pane => <TabPane tab={pane.title} key={pane.key}></TabPane>)}
                </Tabs>
                <div>&nbsp;</div>
                <ConfigProvider renderEmpty={() => { return (<Empty />); }}>
                    {this.state.activeKey === '1' ?
                        <span>
                            <Table columns={weightColumn}
                                bordered
                                rowKey={record => record._id} //unique key needed, so we use mongodb id
                                dataSource={this.state.weightData} //the data source is what we get after component mount
                            />
                            <Button onClick={this.copyWeight} size="large" type="primary">Copy survey weight data to project</Button>
                            <Divider />
                        </span> : this.state.activeKey === '2' ?
                            <span>
                                {this.state.alternativeTable}
                                {/* <Button onClick={this.copyScores} size="large" type="primary">Copy survey evaluation (normalized) scores to project</Button> */}
                                {/* <Divider /> */}
                            </span>
                            : this.state.activeKey === '3' ?
                                <span>
                                    <Button onClick={this.showComModal} size="large" type="primary"> <b>{"\uFF0B\n"}</b> Add comparison groups</Button>
                                    <Button onClick={this.showGraph} style={{ marginLeft: 8 }} size="large" type="primary">Question detail</Button>

                                    <ReactEcharts
                                        option={this.state.comOption}
                                        onEvents={this.onEvents()}
                                        style={{ height: '75vh', width: '100%' }}
                                    />
                                    <Row style={{ textAlign: "center" }} type="flex" justify="space-between" className="steps-action">
                                        <Col span={8} offset={16} ><Button onClick={this.graphReset}>Reset</Button></Col>
                                    </Row>
                                    <Divider />
                                </span>
                                // : this.state.activeKey === '4' ?
                                //     <span>
                                //         <Button onClick={this.showComModal} type="primary"> <b>{"\uFF0B\n"}</b> Add comparison groups</Button>
                                //         {/* <ReactEcharts
                                //             option={this.handleChart()}
                                //             // onEvents={this.onEvents()}
                                //             style={{ height: '75vh', width: '100%' }}
                                //         /> */}
                                //     </span> 
                                :
                                <span></span>}
                    {/* <ReactEcharts
                        option={this.handleChart()}
                        // onEvents={this.onEvents()}
                        style={{ height: '75vh', width: '100%' }}
                    /> */}
                </ConfigProvider>
                <div className="steps-action">
                    {/* disabled={this.checkDisable(this.state.project)} */}
                    <Button size="large" type="primary" >
                        <Link to={`/mamcasurveysetting/${this.props.match.params.projectid}`}>Back</Link></Button>
                </div>
                {/* <Divider /> */}
            </Spin>
            <ComForm
                wrappedComponentRef={this.saveFormRef}
                visible={this.state.comVisible}
                onCancel={this.handleComCancel}
                onCreate={this.handleSubmit}
                treeData={this.state.treeData}
            />
            <Modal
                title="Question detail pie chart"
                visible={this.state.graphVisible}
                onOk={this.handleGraphOk}
                onCancel={this.handleGraphCancel}
                width={1200}
            >
                <Dropdown.Button overlay={this.state.menu} icon={<Icon type="question" />}>
                    Question
                </Dropdown.Button>
                <ReactEcharts
                    option={this.getPieChartOption()}
                // onEvents={this.onEvents()}
                />

            </Modal>
        </div>;
    }
}
